import React from 'react';
import SVG from './SVG.jsx';
import Drawer from './Drawer.jsx';


const stringToDocFrag = (str) => {
  const parser = new window.DOMParser();
  const doc = parser.parseFromString(str, 'text/html');
  const bodyChildren = Array.from(doc.body.children);
  const docFrag = document.createDocumentFragment();
  bodyChildren.forEach((child) => {
    docFrag.appendChild(child);
  });
  return docFrag;
};


export default class ProductDescription extends React.PureComponent {
  constructor(props) {
    super();

    const descriptionTemp = document.createElement('div');
    descriptionTemp.innerHTML = props.description;
    const descriptionHeadings = descriptionTemp.querySelectorAll('h2');
    descriptionHeadings.forEach(heading => heading.insertAdjacentHTML('beforeend', '<span class="icon"><span class="plus"><svg class="svg-icon icon-plus" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#reuse-plus"></use></svg></span><span class="minus"><svg class="svg-icon icon-minus" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#reuse-minus"></use></svg></span></span>'));

    this.descriptionHtml = descriptionTemp.innerHTML;

    this.defaultIntro = null;
    const releaseNotesSectionBlock = props.blocks.find((block) => (block.type === 'release_notes'));
    if (releaseNotesSectionBlock) {
      const defaultIntro = releaseNotesSectionBlock.settings.default_intro;
      if (defaultIntro) {
        this.defaultIntro = defaultIntro;
      }
    }

    this.ref = React.createRef();

    this.state = {
      releaseNotesModalOpen: false,
    };

    this._showReleaseNotes = this._showReleaseNotes.bind(this);
    this._hideReleaseNotes = this._hideReleaseNotes.bind(this);
  }

  componentDidMount() {
    this.ref.current.querySelectorAll('h2').forEach(h2 => {
      h2.addEventListener('click', (e) => {
        e.currentTarget.classList.toggle('expanded');
      })
    })
  }

  _showReleaseNotes() {
    this.setState({releaseNotesModalOpen: true});
  }

  _hideReleaseNotes() {
    this.setState({releaseNotesModalOpen: false});
  }

  _buildReleaseNotes(releaseNotes) {
    const splitTitle = this.props.productTitle.split('|');
    const style = releaseNotes.style || splitTitle[0];
    const color = (
      releaseNotes.color ||
      ((splitTitle.length > 1) && this.props.productTitle.split('|')[1])
    );
    return (
      <div className="release-notes">
        <SVG icon="info"></SVG>
        <div className="rte text-content">
          <div className="release-notes__subtitle">
            A summary of product changes made to enhance the value for customers.
          </div>
          <div
            className="release-notes__intro"
            dangerouslySetInnerHTML={{__html: releaseNotes.intro || this.defaultIntro}}
          >
          </div>
          <ul className="release-notes__properties">
            {style ? <li><span>Style</span>: {style}</li> : null}
            {color ? <li><span>Color</span>: {color}</li> : null}
            {releaseNotes.last
              ? <li><span>Last</span>: {releaseNotes.last_link != '' ? <a href={releaseNotes.last_link}> {releaseNotes.last} </a> : releaseNotes.last } </li>
              : null
            }
          </ul>
          <div className="release-notes__timeline" dangerouslySetInnerHTML={{__html: releaseNotes.timeline}}></div>
        </div>
      </div>
    );
  }

  _buildDescription() {
    const releaseNotes = this.props.metafields.releaseNotes;
    const hasReleaseNotes = Boolean(releaseNotes && releaseNotes.timeline);

    if (hasReleaseNotes === false) {
      return (
        <div
          ref={this.ref}
          className="product-description rte"
          dangerouslySetInnerHTML={{__html: this.descriptionHtml}}
        >
        </div>
      );
    } else {
      // All products have the same description structure, only the number and content of the <li>'s changes.
      // The release notes trigger/drawer is a React component. In order to append the release notes component
      // to the "Product Features" list, we convert the product description string to jsx.

      const docFrag = stringToDocFrag(this.descriptionHtml);

      const featuresWrapper = docFrag.querySelector('.product-features-wrapper');
      const featuresTitle = docFrag.querySelector('.product-features-wrapper .description-title');
      const featuresListWrapper = docFrag.querySelector('.product-features-wrapper .product-features-list');
      const featuresList = docFrag.querySelector('.product-features-wrapper ul');
      const featuresListItems = Array.from(docFrag.querySelectorAll('.product-features-wrapper li'));

      const shippingInfoWrapper = docFrag.querySelector('.product-shipping-info-wrapper');
      const shippingInfoTitle = docFrag.querySelector('.product-shipping-info-wrapper .description-title');
      const shippingInfoList = docFrag.querySelector('.product-shipping-info-wrapper ul');
      const shippingInfoListItems = docFrag.querySelectorAll('.product-shipping-info-wrapper li');
      const hasShippingInfoSection = (
        shippingInfoWrapper &&
        shippingInfoTitle &&
        shippingInfoList &&
        shippingInfoListItems.length
      );

      // If there is no features list, abort jsx conversion and insert description as a string.
      if (
        !featuresWrapper ||
        !featuresTitle ||
        !featuresListWrapper ||
        !featuresList ||
        !featuresListItems.length
      ) {
        return (
          <div
            ref={this.ref}
            className="product-description rte"
            dangerouslySetInnerHTML={{__html: this.descriptionHtml}}
          >
          </div>
        );
      }

      const accordionIcon = (
        <span className="icon">
          <span className="plus"><SVG icon="plus"/></span>
          <span className="minus"><SVG icon="minus"/></span>
        </span>
      );

      return (
        <div ref={this.ref} className="product-description rte">
          <div className="product-features-wrapper">
            <h2 className="description-title">
              {featuresTitle.textContent}
              {accordionIcon}
            </h2>
            <div className="product-features-list">
              <ul>
                {Array.from(featuresListItems).map((li, i) => {
                  return <li key={i} dangerouslySetInnerHTML={{__html: li.innerHTML}}></li>;
                })}
              </ul>
              <div className="product-description__release-notes-wrapper">
                <button className="product-description__release-notes-button" onClick={this._showReleaseNotes}>
                  <span>Release Notes</span>
                  <SVG icon="info" />
                </button>
                <Drawer
                  open={this.state.releaseNotesModalOpen}
                  heading="Release Notes"
                  content={this._buildReleaseNotes(releaseNotes)}
                  contentClass="release-notes__content"
                  _close={this._hideReleaseNotes}
                  mountOnEnter={false}
                  unmountOnExit={true}
                />
              </div>
            </div>
          </div>

          {hasShippingInfoSection &&
            <div className="product-shipping-info-wrapper">
              <h2 className="description-title">
                {shippingInfoTitle.textContent}
                {accordionIcon}
              </h2>
              <ul>
                {Array.from(shippingInfoListItems).map((li, i) => {
                  return <li key={i} dangerouslySetInnerHTML={{__html: li.innerHTML}}></li>;
                })}
              </ul>
            </div>
          }
        </div>
      );
    }
  }

  render() {
    return (
      <div className="product-description-container">
        {this._buildDescription()}
      </div>
    );
  }
}
